import dayjs from "dayjs";
import React from "react";
import { OtPosition } from "./PositionStats";
import { AreaChart } from "@mantine/charts";
import _ from "lodash";
import PaperBlocks from "./PaperBlocks";

interface Props {
    opening: OtPosition;
    width: number;
}

const RatedStats: React.FC<Props> = ({ opening, width }) => {
    const attempts = opening.OtAttempt2?.filter((attempt) => attempt.isRated);

    const dataPoints = attempts?.map((attempt) => {
        return {
            date: dayjs(attempt.createdAt).format("D. MMM"),
            rating: parseInt(attempt.positionRating as string) + parseInt(attempt.ratingGain),
        };
    });

    const firstDataPoint = {
        date: dayjs(_.first(attempts)?.createdAt).format("D. MMM"),
        rating: parseInt((_.first(attempts)?.positionRating as string) || "0"),
    };
    const graphData = [firstDataPoint, ...dataPoints];

    const isMobile = width < 520;

    return (
        <div className="flex space-x-10 [@media(max-width:900px)]:flex-col [@media(max-width:900px)]:space-y-12 [@media(max-width:900px)]:items-center [@media(max-width:900px)]:space-x-0">
            {!_.isEmpty(graphData) && (
                <div className="flex justify-center">
                    <AreaChart
                        strokeWidth={3}
                        h={isMobile ? 370 : 500}
                        w={isMobile ? 370 : 500}
                        data={graphData}
                        dataKey="date"
                        series={[{ name: "rating", color: "indigo.6" }]}
                        curveType="linear"
                        areaProps={{ isAnimationActive: true, animationDuration: 1000 }}
                        gridAxis="x"
                        xAxisProps={{ interval: Math.floor(graphData.length / 5) }}
                        withDots={graphData.length <= 15}
                    />
                </div>
            )}
            <PaperBlocks opening={opening} />
        </div>
    );
};

export default RatedStats;
